module.exports = __webpack_public_path__ + "assets/img/btn-view-all-898bd5b7.png";